import { useSyncExternalStore } from 'react'

function subscribe(onStoreChange: () => void) {
  if (typeof document === `undefined`) return () => {}
  const observer = new MutationObserver(onStoreChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: [`class`] })
  return () => observer.disconnect()
}

function getSnapshot(): boolean {
  return typeof document !== `undefined` && document.documentElement.classList.contains(`dark`)
}

/**
 * Subscribes to <html>'s `dark` class, which useThemeSync keeps in sync with the resolved
 * theme. A MutationObserver behind useSyncExternalStore lets a component track theme changes
 * without depending on the settings/feature-toggle stores that produced the class.
 */
export function useIsDarkMode(): boolean {
  return useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => false, // server snapshot (SPA has no SSR), kept so the hook is total
  )
}
